import React from 'react';
import { Link } from 'react-router-dom';
import { useLang } from '../context/LanguageContext';
import { t } from '../translations';

export default function LegalPage() {
  const { lang } = useLang();
  const tr = t[lang];
  const lTr = tr.legalPage;

  return (
    <main data-testid="legal-page" className="pt-32 pb-24" style={{ backgroundColor: '#0A1A1A' }}>
      <div className="section-container max-w-3xl mx-auto">
        <h1 className="font-sora font-black text-3xl md:text-4xl text-white mb-4">{lTr.title}</h1>
        <p className="text-gray-400 text-sm font-inter mb-12">
          {lang === 'fr' ? 'Dernière mise à jour : Janvier 2025' : 'Last updated: January 2025'}
        </p>
        <div className="space-y-10">
          {lTr.sections.map((s, i) => (
            <div key={i} data-testid={`legal-section-${i}`}>
              <h2 className="font-sora font-bold text-xl text-white mb-4 pb-3 border-b border-white/10">
                {s.title}
              </h2>
              <p className="text-gray-300 font-inter leading-relaxed">{s.content}</p>
            </div>
          ))}
        </div>
        <div className="mt-12 pt-8 border-t border-white/10">
          <Link to="/" className="text-exevori-primary hover:underline font-inter text-sm">
            ← {lang === 'fr' ? 'Retour à l\'accueil' : 'Back to Home'}
          </Link>
        </div>
      </div>
    </main>
  );
}
